import React, { Component } from 'react';
import {
  Modal,
  Card,
  Row,
  Col,
  Typography,
  Space,
  InputNumber,
  Button,
  message,
} from 'antd';
import {
  CalculatorOutlined,
  DollarOutlined,
  CheckOutlined,
  ClearOutlined,
} from '@ant-design/icons';
import { dineroDisabledMask } from '../../../../Components/Items';

const { Title, Text } = Typography;

class ModalConteoEfectivo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Billetes
      billete1000: 0,
      billete500: 0,
      billete200: 0,
      billete100: 0,
      billete50: 0,
      billete20: 0,
      
      // Monedas
      moneda20: 0,
      moneda10: 0,
      moneda5: 0,
      moneda2: 0,
      moneda1: 0,
      moneda050: 0,
      moneda020: 0,
      moneda010: 0,
    };
  }

  componentDidMount() {
    // Si ya hay un valor inicial, podemos intentar distribuirlo
    if (this.props.valorInicial > 0) {
      this.distribuirValorInicial();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.valorInicial !== prevProps.valorInicial && this.props.valorInicial > 0) {
      this.distribuirValorInicial();
    }
    
    // Resetear cuando se abre el modal
    if (this.props.visible && !prevProps.visible) {
      this.resetearConteo();
    }
  }

  // Resetear el conteo cuando se abre el modal
  resetearConteo = () => {
    const nuevoState = {};
    this.getDenominaciones().forEach(denominacion => {
      nuevoState[denominacion.key] = 0;
    });
    this.setState(nuevoState);
  };

  // Función para distribuir automáticamente el valor inicial (opcional)
  distribuirValorInicial = () => {
    // Esta función podría pre-llenar con una distribución automática
    // Por ejemplo, usando la denominación más grande primero
    let restante = this.props.valorInicial;
    const denominaciones = this.getDenominaciones().sort((a, b) => b.valor - a.valor);
    const nuevoState = {};
    
    denominaciones.forEach(denominacion => {
      const cantidad = Math.floor(restante / denominacion.valor);
      nuevoState[denominacion.key] = cantidad;
      restante -= cantidad * denominacion.valor;
    });
    
    this.setState(nuevoState);
  };

  // Definir las denominaciones con sus valores
  getDenominaciones = () => {
    return [
      // Billetes
      { key: 'billete1000', nombre: '$1,000', valor: 1000, tipo: 'billete', color: '#722ed1' },
      { key: 'billete500', nombre: '$500', valor: 500, tipo: 'billete', color: '#eb2f96' },
      { key: 'billete200', nombre: '$200', valor: 200, tipo: 'billete', color: '#f5222d' },
      { key: 'billete100', nombre: '$100', valor: 100, tipo: 'billete', color: '#fa541c' },
      { key: 'billete50', nombre: '$50', valor: 50, tipo: 'billete', color: '#fa8c16' },
      { key: 'billete20', nombre: '$20', valor: 20, tipo: 'billete', color: '#faad14' },
      
      // Monedas
      { key: 'moneda20', nombre: '$20', valor: 20, tipo: 'moneda', color: '#a0d911' },
      { key: 'moneda10', nombre: '$10', valor: 10, tipo: 'moneda', color: '#52c41a' },
      { key: 'moneda5', nombre: '$5', valor: 5, tipo: 'moneda', color: '#13c2c2' },
      { key: 'moneda2', nombre: '$2', valor: 2, tipo: 'moneda', color: '#1890ff' },
      { key: 'moneda1', nombre: '$1', valor: 1, tipo: 'moneda', color: '#2f54eb' },
      { key: 'moneda050', nombre: '$0.50', valor: 0.5, tipo: 'moneda', color: '#597ef7' },
      { key: 'moneda020', nombre: '$0.20', valor: 0.2, tipo: 'moneda', color: '#b37feb' },
      { key: 'moneda010', nombre: '$0.10', valor: 0.1, tipo: 'moneda', color: '#ffadd2' },
    ];
  };

  // Calcular el total
  calcularTotal = () => {
    const denominaciones = this.getDenominaciones();
    let total = 0;
    
    denominaciones.forEach(denominacion => {
      const cantidad = this.state[denominacion.key] || 0;
      total += cantidad * denominacion.valor;
    });
    
    return Math.round(total * 100) / 100; // Redondear a 2 decimales
  };

  // Calcular totales por tipo
  calcularTotalBilletes = () => {
    const denominaciones = this.getDenominaciones().filter(d => d.tipo === 'billete');
    let total = 0;
    
    denominaciones.forEach(denominacion => {
      const cantidad = this.state[denominacion.key] || 0;
      total += cantidad * denominacion.valor;
    });
    
    return Math.round(total * 100) / 100;
  };

  calcularTotalMonedas = () => {
    const denominaciones = this.getDenominaciones().filter(d => d.tipo === 'moneda');
    let total = 0;
    
    denominaciones.forEach(denominacion => {
      const cantidad = this.state[denominacion.key] || 0;
      total += cantidad * denominacion.valor;
    });
    
    return Math.round(total * 100) / 100;
  };

  // Limpiar todos los valores
  limpiarTodo = () => {
    const nuevoState = {};
    this.getDenominaciones().forEach(denominacion => {
      nuevoState[denominacion.key] = 0;
    });
    this.setState(nuevoState);
    message.info('Conteo reiniciado');
  };

  // Distribuir automáticamente
  distribuirAutomatico = () => {
    if (this.props.valorInicial > 0) {
      this.distribuirValorInicial();
      message.info('Distribución automática aplicada');
    } else {
      message.warning('No hay valor inicial para distribuir');
    }
  };

  // Manejar cambio en cantidad
  handleCantidadChange = (key, value) => {
    this.setState({ [key]: value || 0 });
  };

  // Confirmar y enviar el total calculado
  handleConfirmar = () => {
    const total = this.calcularTotal();
    
    if (total <= 0) {
      message.warning('El total debe ser mayor a 0');
      return;
    }
    
    this.props.onConfirmar(total);
    message.success(`Conteo confirmado: ${dineroDisabledMask(total.toFixed(2))}`);
  };

  // Manejar cancelar
  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    const { visible, onCancel } = this.props;
    const denominaciones = this.getDenominaciones();
    const total = this.calcularTotal();
    
    const billetes = denominaciones.filter(d => d.tipo === 'billete');
    const monedas = denominaciones.filter(d => d.tipo === 'moneda');

    return (
      <Modal
        title={
          <Space>
            <DollarOutlined style={{ color: '#52c41a' }} />
            <span>Conteo de Efectivo</span>
          </Space>
        }
        visible={visible}
        onCancel={onCancel}
        footer={null}
        width={800}
        centered
      >
        <div style={{ padding: '0 8px' }}>
          {/* Sección de Billetes */}
          <Card 
            title={
              <Space>
                <span style={{ color: '#722ed1' }}>💵</span>
                <Text strong>Billetes</Text>
              </Space>
            }
            style={{ marginBottom: '16px' }}
            size="small"
          >
            <Row gutter={[16, 16]}>
              {billetes.map((denominacion) => (
                <Col span={8} key={denominacion.key}>
                  <div style={{ 
                    border: '1px solid #e8e8e8', 
                    borderRadius: '6px', 
                    padding: '12px',
                    backgroundColor: '#fafafa'
                  }}>
                    <Row align="middle" gutter={[8, 8]}>
                      <Col span={24}>
                        <div style={{ 
                          backgroundColor: denominacion.color,
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          textAlign: 'center',
                          marginBottom: '8px',
                          fontWeight: 'bold'
                        }}>
                          {denominacion.nombre}
                        </div>
                      </Col>
                      <Col span={12}>
                        <Text style={{ fontSize: '12px' }}>Cantidad:</Text>
                      </Col>
                      <Col span={12}>
                        <InputNumber
                          value={this.state[denominacion.key]}
                          onChange={(value) => this.handleCantidadChange(denominacion.key, value)}
                          min={0}
                          style={{ width: '100%' }}
                          size="small"
                        />
                      </Col>
                      <Col span={24}>
                        <Text style={{ fontSize: '12px', color: '#666' }}>
                          Subtotal: {dineroDisabledMask(((this.state[denominacion.key] || 0) * denominacion.valor))}
                        </Text>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>

          {/* Sección de Monedas */}
          <Card 
            title={
              <Space>
                <span style={{ color: '#faad14' }}>🪙</span>
                <Text strong>Monedas</Text>
              </Space>
            }
            style={{ marginBottom: '16px' }}
            size="small"
          >
            <Row gutter={[16, 16]}>
              {monedas.map((denominacion) => (
                <Col span={6} key={denominacion.key}>
                  <div style={{ 
                    border: '1px solid #e8e8e8', 
                    borderRadius: '6px', 
                    padding: '12px',
                    backgroundColor: '#fafafa'
                  }}>
                    <Row align="middle" gutter={[8, 8]}>
                      <Col span={24}>
                        <div style={{ 
                          backgroundColor: denominacion.color,
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          textAlign: 'center',
                          marginBottom: '8px',
                          fontWeight: 'bold',
                          fontSize: '12px'
                        }}>
                          {denominacion.nombre}
                        </div>
                      </Col>
                      <Col span={24}>
                        <Text style={{ fontSize: '11px' }}>Cantidad:</Text>
                      </Col>
                      <Col span={24}>
                        <InputNumber
                          value={this.state[denominacion.key]}
                          onChange={(value) => this.handleCantidadChange(denominacion.key, value)}
                          min={0}
                          style={{ width: '100%' }}
                          size="small"
                        />
                      </Col>
                      <Col span={24}>
                        <Text style={{ fontSize: '11px', color: '#666' }}>
                          {dineroDisabledMask(((this.state[denominacion.key] || 0) * denominacion.valor))}
                        </Text>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}
            </Row>
          </Card>

          {/* Total */}
          <Card 
            style={{ 
              marginBottom: '16px',
              backgroundColor: '#f6ffed',
              border: '1px solid #b7eb8f'
            }}
          >
            <Row justify="space-between" align="middle">
              <Col>
                <Title level={4} style={{ margin: 0, color: '#52c41a' }}>
                  <CalculatorOutlined /> Total Contado:
                </Title>
              </Col>
              <Col>
                <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                  {dineroDisabledMask(total)}
                </Title>
              </Col>
            </Row>
          </Card>

          {/* Botones */}
          <div style={{ textAlign: 'center' }}>
            <Space size="middle">
              <Button
                type="primary"
                icon={<CheckOutlined />}
                onClick={this.handleConfirmar}
                style={{ 
                  backgroundColor: '#52c41a',
                  borderColor: '#52c41a',
                  height: '40px',
                  paddingLeft: '24px',
                  paddingRight: '24px'
                }}
              >
                Confirmar Total
              </Button>
              <Button
                icon={<ClearOutlined />}
                onClick={this.limpiarTodo}
                style={{ height: '40px', paddingLeft: '24px', paddingRight: '24px' }}
              >
                Limpiar Todo
              </Button>
              <Button
                onClick={onCancel}
                style={{ height: '40px', paddingLeft: '24px', paddingRight: '24px' }}
              >
                Cancelar
              </Button>
            </Space>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalConteoEfectivo;